import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGarminComponent } from './simple-icons-garmin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGarminComponent ],
    exports:      [ SimpleIconsGarminComponent ],
    bootstrap:    []
})
export class SimpleIconsGarminModule {}
